var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"features-nav",class:{ 'features-nav--reversed': this.reversed }},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,class:_vm.navItemClass(index),on:{"click":function($event){return _vm.activateImage(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }